var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAnalyticsColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "analytics"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.99902 8.724C5.70398 8.896 5.36499 9 5 9C3.896 9 3 8.104 3 7C3 5.896 3.896 5 5 5C6.10205 5 6.99402 5.89099 6.99902 6.99194L11.001 9.27795C11.296 9.10596 11.635 9 12 9C12.178 9 12.347 9.03101 12.511 9.07397L17.074 4.51196C17.031 4.349 17 4.17896 17 4C17 2.896 17.896 2 19 2C20.104 2 21 2.896 21 4C21 5.104 20.104 6 19 6C18.822 6 18.652 5.97095 18.488 5.927L13.926 10.489C13.969 10.654 14 10.822 14 11C14 12.104 13.104 13 12 13C10.8979 13 10.006 12.11 10.001 11.01L5.99902 8.724ZM22 11V21H24V23H0V21H2V13C2 12.449 2.448 12 3 12H7C7.552 12 8 12.449 8 13V21H9V16C9 15.449 9.448 15 10 15H14C14.552 15 15 15.449 15 16V21H16V11C16 10.449 16.448 10 17 10H21C21.552 10 22 10.449 22 11ZM4 21H6V14H4V21ZM13 21V17H11V21H13ZM18 21H20V12H18V21Z",
  fill: "#464A51"
}))));
export default SvgIconAnalyticsColor;